import {useQuery} from "react-query"
import useAuth from "auth/useAuth"
import {setLocalItem} from "utils/utils"


export default function useMyRescues() {

    const {auth, API} = useAuth()
    const key = 'my-rescues'
        
    const preload = () => {
        const data = localStorage.getItem(key)
        if (!data) return []
        return JSON.parse(data)
    }
    
    const fetched = (data) => {
        setLocalItem(key, data)
    }
    
    const query = useQuery(
        key,
        () => auth(API.rescuesMyGet).then(response => response.data),
        {initialData: preload, onSuccess: fetched}
    )


    return query
}